import RefundInfoLayer from './RefundInfoLayer';

/**
 * @export
 * @class RefundInfo
 * 환불 규정
 */
export default class RefundInfo {
  constructor() {
    // 필요 data 유효 확인
    const {
      bIsDeliveryDeal,
      htDealContentInfo: { bannerViewInfo },
    } = TMON.oApp.htStorage.htStaticData;
    if (
      bIsDeliveryDeal ||
      !bannerViewInfo ||
      bannerViewInfo.hideUnusedRefundInfo ||
      (!bannerViewInfo.hideUnusedRefundRate &&
        bannerViewInfo.hideUnusedRefundRate !== 0)
    ) {
      return;
    }

    this.welWrapper = $('#_wrapRefundInfo');

    this.setEvent();
    this.render();

    this.oRefundInfoLayer = null;
  }

  setEvent() {
    // 배송정보 레이어 열기 eventListener 등록
    this.welWrapper.on(
      'click',
      '[data-role=btnShowRefundInfo]',
      this.handleShowRefundInfoLayer
    );
  }

  clearEvent() {
    if (this.welWrapper) {
      this.welWrapper.off('click', '[data-role=btnShowRefundInfo]');
    }

    if (this.oRefundInfoLayer && this.oRefundInfoLayer.clearEvent) {
      this.oRefundInfoLayer.clearEvent();
    }
  }

  /**
   * 배송정보 레이어 열기 eventListener
   */
  handleShowRefundInfoLayer = () => {
    if (!this.oRefundInfoLayer) {
      this.oRefundInfoLayer = new RefundInfoLayer();
    }

    this.oRefundInfoLayer.open();
  };

  render() {
    const {
      htDealContentInfo: {
        bannerViewInfo: { hideUnusedRefundRate },
      },
    } = TMON.oApp.htStorage.htStaticData;

    const sHtml = `<h3 class="tit_align_left">환불규정</h3>
            <div class="ct delivery_info">
                <button type="button" data-role="btnShowRefundInfo" class="another_view" data-tlarea="MDDIA" data-tlord="6">
                    <p class="p1">
                        ${
                          hideUnusedRefundRate === 0
                            ? '미사용 티켓 환불제 미적용 상품'
                            : `미사용티켓 ${hideUnusedRefundRate}% 티몬캐시·적립금 환불`
                        }
                    </p>
                </button>
            </div>`;

    this.welWrapper.html(sHtml).removeClass('ct_empty');
  }
}
